module.exports = __webpack_public_path__ + "img/Ident-Process-3-mobile.d5289774.png";